import { useEffect } from 'react'

export default function BottomSheet({ open, onClose, title, children }) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [open])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 animate-fade-in">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/30 backdrop-blur-sm" 
        onClick={onClose}
      />
      
      {/* Bottom Sheet */}
      <div className="absolute inset-x-0 bottom-0 bg-white rounded-t-3xl shadow-2xl max-h-[85vh] animate-slide-up safe-area-inset">
        {/* Handle */}
        <div className="w-12 h-1.5 bg-slate-200 rounded-full mx-auto mt-3 mb-2" />
        
        {/* Header */}
        <div className="px-4 pb-2">
          <div className="text-sm font-semibold">{title}</div>
        </div>
        
        {/* Content */}
        <div className="px-4 pb-4 max-h-[70vh] overflow-auto">
          {children}
        </div>
      </div>
    </div>
  )
}
